import { useCallback, useMemo } from 'react';

import {
  useRfqBuilderActions,
  useRfqBuilderView,
} from '@paradigm/features/src/unified-rfqs/ui';

import SelectField from '#/components/UnifiedRfqs/components/SelectField';
import useIsMobile from '@paradigm/design-system/src/hooks/useIsMobile';
import { useTrackAction } from '@paradigm/features/src/analytics';
import { FormOption } from '@paradigm/features/src/unified-rfqs/ui/rfq-builder/types';

export default function StrategySelector() {
  const { options, selectedOption } = useRfqBuilderView().strategy;
  const { selectStrategy } = useRfqBuilderActions();
  const isMobile = useIsMobile();
  const trackAction = useTrackAction();

  const handleOnChange = useCallback(
    (option: FormOption<string | null> | null) => {
      trackAction('update strategy', { strategyCode: option?.value ?? null });
      if (option != null) selectStrategy(option.value);
    },
    [selectStrategy, trackAction],
  );

  return useMemo(
    () => (
      <SelectField
        aria-label="Select strategy"
        options={options}
        value={selectedOption}
        onChange={handleOnChange}
        isSearchable={!isMobile}
      />
    ),
    [handleOnChange, isMobile, options, selectedOption],
  );
}
